export const LOAD_DELIVERY_BOY = "LOAD_DELIVERY_BOY";
